import { render, staticRenderFns } from "./PlayerEmbedScript.vue?vue&type=template&id=46547fdc&"
import script from "./PlayerEmbedScript.vue?vue&type=script&lang=js&"
export * from "./PlayerEmbedScript.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports